import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { getSiteConfig, SiteConfig } from '../services/siteConfigService';
import { useLocale } from '../context/LocaleContext';
import { resolveMessage } from '../i18n/translate';
import styles from '../styles/rootLanding.module.css';

export default function RootLanding() {
  const { t, locale } = useLocale();
  const [config, setConfig] = useState<SiteConfig | null>(null);

  useEffect(() => {
    let cancelled = false;
    getSiteConfig().then((c) => {
      if (!cancelled) setConfig(c);
    });
    return () => { cancelled = true; };
  }, []);

  /**
   * Home text is edited in Admin (English). The catalog holds a translation of
   * the English it was written for; show it only while the Admin text still matches.
   */
  const homeText = (value: string | undefined, key: string): string => {
    if (!value) return t(key);
    if (locale === 'en') return value;
    return value.trim() === resolveMessage(key, { locale: 'en' }).trim() ? t(key) : value;
  };

  const tagline = homeText(config?.tagline, 'home.tagline');
  const sectionHeading = homeText(config?.section_heading, 'home.section_heading');
  const bullet1 = homeText(config?.bullet1, 'home.bullet1');
  const bullet2 = homeText(config?.bullet2, 'home.bullet2');
  const bullet3 = homeText(config?.bullet3, 'home.bullet3');

  return (
    <div className={styles.container}>
      <div className={styles.logoRow}>
        <img
          src="/recovery_commons_icon.png"
          alt="Recovery Commons"
          className={styles.logo}
        />
      </div>
      <h1 className={styles.title}>Recovery Commons</h1>
      <p className={styles.tagline}>{tagline}</p>

      <section className={styles.whatIs}>
        <h2 className={styles.whatIsTitle}>{sectionHeading}</h2>
        <ul className={styles.bullets}>
          <li>{bullet1}</li>
          <li>{bullet2}</li>
          <li>{bullet3}</li>
        </ul>
      </section>

      <Link to="/saa" className={styles.programCard}>
        <span className={styles.programName}>SAA</span>
        <span className={styles.programSubtitle}>{t('home.saa_subtitle')}</span>
      </Link>
      <p className={styles.comingSoon}>{t('home.open_saa_hint')}</p>
      <p className={styles.comingSoon}>{t('home.more_programs')}</p>
    </div>
  );
}
